// hooks/useUserCountry.js
import { useEffect, useState } from 'react';

export default function useUserCountry() {
  const [country, setCountry] = useState(null);
  const [usercountryscope, setUsercountryscope] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem('userCountryscope');
    if (stored) {
      setUsercountryscope(JSON.parse(stored));
      setCountry(stored);
      setLoading(false);
      return;
    }

    async function fetchCountry() {
        setLoading(true);
        let userScopes = [];
      try {
        const res = await fetch('https://ipapi.co/json/');
        const data = await res.json();
        if (data && data.country_code) {
            userScopes.push({
              name: data.country_name,
              countryCode: data.country_code,
              phone_code: data.country_calling_code
            });
          setUsercountryscope(userScopes);
          localStorage.setItem('userCountryscope',JSON.stringify(userScopes));
          setCountry(data);
        }
      } catch (error) {
        console.error("Failed to detect user country", error);
      } finally {
        setLoading(false);
      }
    }

    fetchCountry();
  }, []);

  return { country, loading, usercountryscope, setUsercountryscope };
}
